import React from 'react';

import { SVGComponentProps } from './svg.types';

const AIBulletSVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherProps
}: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <rect x="0.5" y="0.5" width="35" height="35" rx="7.5" stroke="#E5E7EB" />
      <rect x="4" y="4" width="28" height="28" rx="4" fill="#F1F3F5" />
      <g clipPath="url(#clip0_12_1053)">
        <path
          d="M21.3338 10.8054L22.213 12.454L23.8615 13.3332L22.213 14.2124L21.3338 15.861L20.4545 14.2124L18.806 13.3332L20.4545 12.454L21.3338 10.8054ZM17.1115 16.2221L20.4449 17.9999L17.1115 19.7777L15.3338 23.111L13.556 19.7777L10.2227 17.9999L13.556 16.2221L15.3338 12.8888L17.1115 16.2221ZM17.6115 17.9999L16.126 17.2076L15.3338 15.7221L14.5415 17.2076L13.056 17.9999L14.5415 18.7921L15.3338 20.2777L16.126 18.7921L17.6115 17.9999ZM23.1115 20.8888L22.0005 18.8055L20.8893 20.8888L18.806 21.9999L20.8893 23.111L22.0005 25.1943L23.1115 23.111L25.1949 21.9999L23.1115 20.8888Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_12_1053">
          <rect width="16" height="16" fill="white" transform="translate(10 10)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AIBulletSVG;
